"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
function BlogListingConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">Failed to load blog posts.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="card group overflow-hidden">
          {post.featuredImage && <div className="overflow-hidden">
              <img src={post.featuredImage} alt={post.title} className="w-full h-56 object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:scale-105" />
            </div>}
          <CardHeader>
            <CardTitle className="text-xl text-primary line-clamp-2">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="flex-1">
            {post.excerpt && <p className="text-muted-foreground text-sm line-clamp-3">
                {post.excerpt.replace(/<[^>]*>/g, "")}
              </p>}
          </CardContent>
          <CardFooter>
            <Link to={post.link || "#"} className="inline-flex items-center text-sm font-semibold text-secondary hover:text-foreground transition-colors duration-[var(--duration-fast)]">
              Read More
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-2">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function BlogListing() {
  return <section className="py-16 px-6 bg-light-background">
      <div className="max-w-7xl mx-auto">
        <div className="relative text-center mb-12 py-20 px-6 rounded-xl bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/image_35fyfjy0.png)] overflow-hidden">
          <div className="absolute inset-0 bg-primary-dark/70"></div>
          <div className="relative z-10">
            <h2 className="text-4xl font-display font-bold text-white mb-4">
              Latest from Our Blog
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Explore helpful articles, study tips, and educational insights to support your learning journey.
            </p>
          </div>
        </div>
        <PostsProvider wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "_embedded", "_links.wp:featuredmedia"]}>
          <BlogListingConsumer />
        </PostsProvider>
      </div>
    </section>;
}